<script>
    import getTime from '../../js/helpers/getTime';
    import makeLinksClickable from '../../js/helpers/makeLinksClickable';

    export default {
        props: {
            message: Object,
            type: String,
            bgColor: String,
            icons: Object,
            textColor: String,
        },
        methods: {
            getMessageTime(time) {
                return getTime(time)
            },
            makeLinks(text) {
                return makeLinksClickable(text)
            }
        },
        computed: {
            userStyles() {
                return {
                    maxWidth: this.icons.userIcon ? '75%' : '80%'
                }
            },
            botStyles() {
                return {
                    maxWidth: this.icons.agentIcon ? '75%' : '80%',
                    backgroundColor: this.bgColor
                }
            }
        },
    }
</script>

<template>
    <li class="list__item" v-if="message">
        <div v-if="message.question" class="demo__user-wrapper">
            <div class="demo__user-message" :style="userStyles">
                <p class="demo__message-text" :style="{color: this.textColor}" v-html="makeLinks(message.question)"></p>
                <p v-if="message.question" class="chatbot_preview__time">{{ getMessageTime(message.qCreatedAt) }}</p>
            </div>
            <div v-if="icons.userIcon" class="demo__chat-icon">
                <img :src="icons.userIcon" alt="" />
            </div>
        </div>

        <div v-if="message.answer" class="demo__bot-wrapper">
            <div v-if="icons.agentIcon" class="demo__chat-icon">
                <img :src="icons.agentIcon" alt="" />
            </div>
            <div class="demo__bot-message" :class="{error: message.error}" :style="botStyles">
                <p class="demo__message-text" v-html="makeLinks(message.answer)"></p>
                <p v-if="message.answer" class="chatbot_preview__time chatbot_preview__time--left" :class="{error: message.error}">{{ getMessageTime(message.aCreatedAt) }}</p>
            </div>

        </div>
    </li>    
</template>

<style scoped lang="scss">
.list__item {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.demo__bot-wrapper {
    display: flex;
    gap: 5px;
}

.demo__bot-message {
    font-family: 'Inter', sans-serif;
    margin: 0;
    padding: 10px 15px;
    border-radius: 0px 16px 16px 16px;
    color: #fff;
    font-weight: 400;
    line-height: 1.5;
    margin-right: auto;

    &.error {
        background-color: transparent !important;
        border: 1px solid #eb5757;
        color: #eb5757;
    };
}

.demo__user-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
}

.demo__user-message {
    font-family: 'Inter', sans-serif;
    margin: 0;
    padding: 10px 15px;
    border-radius: 16px 0px 16px 16px;
    background-color: #e6edff;
    color: #4f4f4f;
    font-size: 1em;
    font-weight: 400;
    line-height: 1.5;
}

.demo__message-text {
    font-family: inherit;
    padding: 0;
    margin: 0;
    font-size: 1em;
    font-weight: 400;
    line-height: 1.5;
    max-width: 100%;
    /* display: block; */
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.demo__chat-icon {
    overflow: hidden;
    position: relative;
    border-radius: 50%;
    object-fit: cover;
    min-width: 24px;
    max-width: 24px;
    height: 24px;

    & img {
        position: absolute;
        top: 0;
        height: 0;
        width: 100%;
        height: 100%;
    }
}

.chatbot_preview__time {
    font-family: inherit;
    margin-top: 3px;
    padding: 0;
    color: #4f4f4f;
    text-align: right;
    font-size: 0.7em;
    font-weight: 400;
    line-height: 1.33;
    text-align: right;
    opacity: 0.6;

    &--left {
        color: #fff;
    }

    &.error {
        color: #eb5757;
    }
}

</style>